(function () {
  'use strict';

  // Mobile menu
  function initMenu() {
    var nav = document.querySelector('[data-tt-nav]');
    if (!nav) return;
    var toggles = document.querySelectorAll('[data-tt-menu-toggle]');
    var burger = document.querySelector('.tt-header__burger');
    function set(open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('tt-menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () { set(!nav.classList.contains('is-open')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && !e.target.closest('[data-tt-menu-toggle]')) set(false);
    });
  }

  // Review slider
  function initSliders(root) {
    (root || document).querySelectorAll('[data-tt-slider]').forEach(function (slider) {
      if (slider.__ttInit) return;
      slider.__ttInit = true;
      var slides = slider.querySelectorAll('[data-tt-slide]');
      if (!slides.length) return;
      var i = 0, timer;
      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      function auto() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { go(i + 1); }, 7000); }
      var prev = slider.querySelector('[data-tt-prev]');
      var next = slider.querySelector('[data-tt-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); auto(); });
      if (next) next.addEventListener('click', function () { go(i + 1); auto(); });
      auto();
    });
  }

  // Product page: keep hidden variant id + price in sync with option selects
  function initProduct() {
    var form = document.querySelector('[data-tt-product-form]');
    var json = document.querySelector('[data-tt-product-json]');
    if (!form || !json) return;
    var product = JSON.parse(json.textContent);
    var selects = form.querySelectorAll('[data-tt-option]');
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var price = document.querySelector('[data-tt-price]');
    var money = function (c) {
      return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) :
        new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(c / 100);
    };
    function update() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); });
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (price) price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><span class="is-sale">' + money(v.price) + '</span>' : money(v.price));
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu(); initSliders(); initProduct();
  });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
})();
